import { Button } from 'antd'
import { Header } from 'antd/es/layout/layout'
import Logo from '../../../Assets/supportroom-logo.svg'
import React from 'react'

const optionRenderList = [
    {
        title: 'About',
        linkTo: '/b2b2c/about',
    },
    {
        title: 'How It Works',
        linkTo: '/b2b2c/how-it-works',
    },
    {
        title: 'Why Choose',
        linkTo: '/b2b2c/why-choose',
    },
    {
        title: 'Contact',
        linkTo: '/b2b2c/contact',
    },
    {
        title: 'Blog',
        linkTo: '/b2b2c/blog',
    }
]

export const HeaderB2B2C = () => {
    return (
        <Header style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: '#fff',
            padding: '0px 80px'
        }}>
            <img src={Logo} height={40} width={141} />
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                gap: '40px',
                alignItems: 'center'
            }}>
                {
                    optionRenderList?.map((opt) => {
                        return (
                            <div
                                onClick={() => { }}
                                style={{
                                    fontFamily: 'Montserrat',
                                    fontWeight: 500,
                                    fontStyle: 'normal', // "Medium" isn't a valid CSS value — use weight for that
                                    fontSize: '14px',
                                    lineHeight: '100%', // this is fine as a string
                                    letterSpacing: '0%',
                                    textAlign: 'center',
                                    verticalAlign: 'middle',
                                    cursor: 'pointer'
                                }}
                            >
                                {opt.title}
                            </div>

                        )
                    })
                }

            </div>
            <Button style={{
                height: '40px',
                width: '95px',
                borderWidth: '1px',
                borderColor: '#28BF8D',
                borderRadius: '10px',
                color: '#28BF8D',
                fontFamily: 'Montserrat',
                fontWeight: 600,
                fontSize: '16px'
            }}>
                Login
            </Button>
        </Header>
    )
}
